<template>
  <div class="source d-flex align-center justify-center">
    <div class="source-content d-flex f-column align-center justify-center">
      <h3>猪肉区块链溯源</h3>
      <p>
        区块链技术给互联网深化发展带来巨大的想象空间，引发互联网上传统信任机制的改变，
        区块链技术应用于溯源系统中的数据存储，由于其天生的特征，存储的数据难以删除和更改，
        提供了一种区别于原来溯源系统中心化数据存储的新信任机制，因此极大的提高了溯源系统的可信度。
        根据数据溯源的产生和使用过程，要能够很好地管理数据溯源信息，首先需要有一个统领全局的架构。
        由于区块链技术的可追溯性和防篡改性，与溯源需求正好契合，结合区块链的溯源架构能够满足实际生产的要求。
      </p>
      <el-table :data="list" border :header-cell-class-name="headerBgColor" style="width: 100%">
        <el-table-column align="center" prop="sourcecode" label="溯源编码"> </el-table-column>
        <el-table-column align="center" prop="busname" label="存证名称"> </el-table-column>
        <el-table-column align="center" prop="hogtype_dictText" label="存证类型"> </el-table-column>
        <el-table-column align="center" prop="hogstatus_dictText" label="存证状态"> </el-table-column>
        <el-table-column align="center" prop="createTime" label="存证时间"> </el-table-column>
        <el-table-column align="center" prop="address" label="查看存证" width="160">
			
         <template slot-scope="scope">
			<el-image 
			  style="display: block;width: 0.8rem;cursor: pointer;margin: 0 auto;"
			  :src="'https://trace.hogdata.cn/hogchain-boot/'+scope.row.file1"
			  :preview-src-list="['https://trace.hogdata.cn/hogchain-boot/'+scope.row.file1]">
			</el-image>
			
          </template>
          <!-- <template>
            <div class="checked" @expand-change="cha()">查看</div>
          </template> -->
        </el-table-column>
      </el-table>
	    <el-pagination
		style="margin-top: 0.5rem;"
	      layout="prev, pager, next"
		  @current-change="handleSizeChange"
	      :total="pagelength">
	    </el-pagination>
    </div>
    <!-- <div class="showimg" v-show="imgshow" >
      <p style="font-size: 0.4rem;color: #333333;text-align: center;line-height: 2rem;">存证查看</p>
      <span @click="closimg">关闭</span>
      <img style="width: 5.5rem;display: block;margin: 0 auto;" :src="'https://trace.hogdata.cn/hogchain-boot/'+imgsrc">
    </div> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list:[],
        pageNo: 1,
        pageSize: 10,
        imgsrc: '',
        imgshow:false,
		pagelength:4,
      }
    },
    methods: {
      // 设置表头背景色
      headerBgColor({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        return 'table-th'
      },
closimg(){
  this.imgshow=false
},
 handleSizeChange(val) {
		this.pageNo=val
		this.newslist()
      },
      newslist() {
        this.list = []
        const url = 'https://trace.hogdata.cn/hogchain-boot//hogchain/hotchainBusChaincode/list';
        this.$http.get(url, {
          params: {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            column:"createTime",
            order:"desc"
          }
        }).then(
          response => {
            console.log(response.body.result)
            this.list = response.body.result.records
			this.pagelength = response.body.result.total
          },

          response => {
            alert('请求失败');
          },
        );
      },
      handleClick(e) {
        console.log(e)
		// window.open('https://trace.hogdata.cn/hogchain-boot/'+e.file1)
		// window.location.href=
        this.imgsrc = e.file1
        this.imgshow = true
      }
    },
    mounted() {
      this.newslist()
    },
  }
</script>

<style lang="scss" scoped>
  .source {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;

    &-content {
      width: 15rem;

      h3 {
        font-size: 0.45rem;
        padding-bottom: 0.25rem;
      }

      p {
        line-height: 0.4rem;
        text-align: center;
        font-size: 0.25rem;
        color: #999;
        margin-bottom: 1rem;
      }

      .checked {
        font-size: 0.2rem;
        color: #2373f0;
        cursor: pointer;
      }
    }

    ::v-deep .el-table {

      td,
      th {
        padding: 0.225rem 0;
      }

      .cell {
        padding-left: 0.125rem;
        padding-right: 0.125rem;
        line-height: 0.2875rem;
        font-size: 0.2rem;
        color: #666;
      }

      .table-th {
        background-color: #f9fafe;
        padding: 0.225rem 0;

        .cell {
          padding-right: 0.125rem;
          font-size: 0.25rem;
          color: #666;
        }
      }
    }

    ::v-deep .el-table .cell {
      th {
        &:first-child {
          .cell {
            padding-left: 0.125rem;
          }
        }
      }
    }
  }
  .showimg{
    display: block;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background-color: #ffffff;
     padding: 30rpx;
     z-index: 999;
  }
  .showimg span{
    display: inline-block;
    position: absolute;
    right: 1rem;
    top:1rem;
    color: #333333;
    font-size: 0.3rem;
    cursor: pointer;
    z-index: 10000;
  }
</style>
